import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Leaflet CSS must be imported before the component
import 'leaflet/dist/leaflet.css';
import './styles/shield.scss';

import ShieldDashboard from './ShieldDashboard.js';
import { SettingsProvider } from './SettingsProvider.js';
import { SessionProvider } from './session/SessionProvider.js';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SettingsProvider>
      <SessionProvider>
        <ShieldDashboard />
      </SessionProvider>
    </SettingsProvider>
  </StrictMode>
);
